import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-scaffold-toast',
    templateUrl: './scaffold-toast.component.html',
    styleUrl: './scaffold-toast.component.scss',
    providers: [MessageService],
    standalone: false
})
export class ScaffoldToastComponent {
  constructor(private messageService: MessageService) {}

  open(settings: any) {
    console.log('Open toast', settings);
    this.messageService.add(settings);
  }
}
